import {
  Box,
  CircularProgress,
  HStack,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/chackra-ui-button";
import { useTaxProfileQuery } from "../../graphql/generated/user-v2-hooks";
import { Routes } from "../../helpers/router";
import { spanishProvinces } from "../../helpers/spanish-provinces";

export const BillingDetailsSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, loading, error } = useTaxProfileQuery({
    context: { endpoint: "fitnextv2" },
    fetchPolicy: "network-only",
  });

  const taxProfile = data?.taxProfile;

  const provinceName = taxProfile?.province
    ? (spanishProvinces.find((p) => p.code === taxProfile.province)?.name ??
      taxProfile.province)
    : "";

  return (
    <Box w="full">
      <HStack justify="space-between" alignItems="center" mb={3} px={1}>
        <Text
          fontSize="20px"
          fontWeight={600}
          fontFamily="'Barlow Semi Condensed', sans-serif"
          color="#13192E"
        >
          {t("billingDetails.title")}
        </Text>
        {taxProfile && (
          <Link
            color="#0078FF"
            fontWeight={600}
            fontSize="16px"
            onClick={() => navigate(Routes.TaxProfile())}
          >
            {t("billingDetails.edit")}
          </Link>
        )}
      </HStack>
      <Box
        bg="white"
        borderWidth="1px"
        borderColor="slate.100"
        borderRadius="12px"
        p={5}
      >
        {loading ? (
          <HStack>
            <CircularProgress isIndeterminate color="blue.500" size={4} />
          </HStack>
        ) : taxProfile ? (
          <VStack w="full" align="start" spacing={0}>
            <Text
              fontFamily="'Barlow Semi Condensed', sans-serif"
              fontWeight={600}
              fontSize="16px"
            >
              {taxProfile.name}
            </Text>
            <Text fontSize="14px" color="slate.500">
              {t("billingDetails.nifPrefix", { nif: taxProfile.nif, interpolation: { escapeValue: false } })}
            </Text>
            <Box
              w="full"
              mt={2}
              pt={2}
              borderTopWidth="1px"
              borderTopColor="slate.200"
            >
              <Text fontSize="14px" color="slate.500">
                {taxProfile.address}
              </Text>
              <Text fontSize="14px" color="slate.500">
                {[taxProfile.city, taxProfile.zipCode, provinceName]
                  .filter(Boolean)
                  .join(", ")}
              </Text>
            </Box>
          </VStack>
        ) : (
          <VStack w="full" align="start" spacing={3}>
            <Text fontSize="14px" color="slate.500">
              {t("billingDetails.ctaDescription")}
            </Text>
            <Button
              variant="senseiFilled"
              onClick={() => navigate(Routes.TaxProfile())}
            >
              {t("billingDetails.ctaButton")}
            </Button>
          </VStack>
        )}
      </Box>
    </Box>
  );
};
